module.exports = __webpack_public_path__ + "img/box_pro_two_4.f15e37eb.jpg";